/* eslint-disable no-empty-pattern */
import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const {Types, Creators} = createActions({
  publicationsRequest: ['page', 'page_size', 'search', 'filter', 'sort', 'nextPage'],
  publicationsSuccess: ['list'],

  followingPublicationsRequest: ['page', 'page_size', 'search', 'filter', 'sort', 'nextPage'],
  followingPublicationsSuccess: ['list'],

  advertiserPublicationsRequest: ['id', 'page', 'page_size', 'search', 'filter', 'sort', 'nextPage'],
  advertiserPublicationsSuccess: ['list'],

  folderPublicationsRequest: ['id', 'page', 'page_size', 'search', 'filter', 'sort', 'nextPage'],
  folderPublicationsSuccess: ['list'],

  preparedPublicationsRequest: ['page', 'page_size', 'search', 'filter', 'sort', 'nextPage'],
  preparedPublicationsSuccess: ['list'],

  scheduledPublicationsRequest: ['page', 'page_size', 'search', 'filter', 'sort', 'nextPage'],
  scheduledPublicationsSuccess: ['list'],

  listPublicationsRequest: ['id', 'page', 'page_size', 'search', 'filter', 'sort', 'nextPage'],
  listPublicationsSuccess: ['list'],

  deleteListPublicationsRequest: ['id', 'data'],
  deleteListPublicationsSuccess: ['deleteListPublicationResult'],
  deleteListPublicationsReset: null,

  publicationRequest: ['id'],
  publicationSuccess: ['focusRow'],
  publicationReset: null,

  followAuthorRequest: ['authorId'],
  followAuthorSuccess: ['authorId', 'followed'],

  savePublicationRequest: ['publicationId', 'folderId'],
  savePublicationSuccess: ['publicationId', 'saved'],
  savePublicationReset: null,

  deleteRestorePublicationRequest: ['publicationId', 'data'],
  deleteRestorePublicationSuccess: ['deleteRestoreResult', 'publicationId'],
  deleteRestorePublicationReset: null,

  publicationsReset: null,

  publicationsFetchingReset: null,

  reportReasonsRequest: null,
  reportReasonsSuccess: ['reportReasons'],
  reportReasonsReset: null,

  sendReportRequest: ['id', 'data'],
  sendReportSuccess: ['sendReportResult'],
  sendReportReset: null,

  reportFetchingReset: null,

  setPublicationsPageColumnSize: ['page_column_size'],

  followingSavedCountRequest: null,
  followingSavedCountSuccess: ['followingSavedCount'],
  followingSavedCountReset: null,
})

export const PublicationsTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  followAuthorFetching: false,
  savePublicationFetching: false,

  reportReasons: null,
  reportReasonsFetching: false,

  sendReportResult: null,
  sendReportFetching: false,

  deleteListPublicationResult: null,
  deleteListPublicationFetching: false,

  deleteRestoreResult: null,
  deleteRestorePublicationFetching: false,

  page: 1,
  page_size: 12,
  page_column_size: 3,

  focusRow: null,

  followingSavedCount: null,
  followingSavedCountFetching: false,
})

/* ------------- Selectors ------------- */
export const PublicationsSelectors = {
  getState: state => state.publications,
}

/* ------------- Reducers ------------- */

export const publicationsRequest = (state, {page, page_size, search, filter, sort, nextPage}) => {
  const newState = {
    fetching: true,
  }

  page && (newState.page = page)
  page_size && (newState.page_size = page_size)

  return state.merge(newState)
}

export const publicationsSuccess = (state, {list}) => {
  //return state.merge({ fetching: false, list })

  if (state.list) {
    if (list.next === null && list.results.length === 0) {
      return state.merge({fetching: false, list: {...state.list, next: null}})
    } else {
      return state.merge({fetching: false, list: {...state.list, results: [...state.list.results, ...list.results]}})
    }
  } else {
    return state.merge({fetching: false, list})
  }
}

export const followingPublicationsRequest = (state, {page, page_size, search, filter, sort}) => {
  const newState = {
    fetching: true,
  }

  page && (newState.page = page)
  page_size && (newState.page_size = page_size)

  return state.merge(newState)
}

export const followingPublicationsSuccess = (state, {list}) => {
  if (list.next === null && list.results.length === 0) {
    return state.merge({fetching: false, list: {...state.list, next: null}})
  }
  return state.merge({fetching: false, list})
}

export const advertiserPublicationsRequest = (state, {id, page, page_size, search, filter, sort}) => {
  const newState = {
    fetching: true,
  }

  page && (newState.page = page)
  page_size && (newState.page_size = page_size)

  return state.merge(newState)
}

export const advertiserPublicationsSuccess = (state, {list}) => {
  if (state.list) {
    if (list.next === null && list.results.length === 0) {
      return state.merge({fetching: false, list: {...state.list, next: null}})
    } else {
      return state.merge({fetching: false, list: {...state.list, results: [...state.list.results, ...list.results]}})
    }
  } else {
    return state.merge({fetching: false, list})
  }
}

export const listPublicationsRequest = (state, {id, page, page_size, search, filter, sort}) => {
  const newState = {fetching: true}

  page && (newState.page = page)
  page_size && (newState.page_size = page_size)

  return state.merge(newState)
}

export const listPublicationsSuccess = (state, {list}) => {
  if (state.list) {
    return state.merge({fetching: false, list: {...state.list, ...list}})
  }
  return state.merge({fetching: false, list})
}

export const deleteListPublicationsRequest = (state, {id, data}) => {
  return state.merge({deleteListPublicationFetching: true})
}

export const deleteListPublicationsSuccess = (state, {deleteListPublicationResult}) => {
  return state.merge({deleteListPublicationFetching: false, deleteListPublicationResult})
}

export const deleteListPublicationsReset = (state, {}) => {
  return state.merge({deleteListPublicationFetching: false, deleteListPublicationResult: null})
}

export const folderPublicationsRequest = (state, {id, page, page_size, search, filter, sort}) => {
  const newState = {
    fetching: true,
  }

  page && (newState.page = page)
  page_size && (newState.page_size = page_size)

  return state.merge(newState)
}

export const preparedPublicationsRequest = (state, {page, page_size, search, filter, sort, nextPage}) => {
  const newState = {
    fetching: true,
  }

  page && (newState.page = page)
  page_size && (newState.page_size = page_size)

  return state.merge(newState)
}

export const preparedPublicationsSuccess = (state, {list}) => {
  if (list.count !== 0 && list.next === null && list.results.length === 0) {
    return state.merge({fetching: false, list: {...state.list, next: null}})
  }
  return state.merge({fetching: false, list})
}

export const scheduledPublicationsRequest = (state, {page, page_size, search, filter, sort, nextPage}) => {
  const newState = {
    fetching: true,
  }

  page && (newState.page = page)
  page_size && (newState.page_size = page_size)

  return state.merge(newState)
}

export const scheduledPublicationsSuccess = (state, {list}) => {
  if (list.count !== 0 && list.next === null && list.results.length === 0) {
    return state.merge({fetching: false, list: {...state.list, next: null}})
  }
  return state.merge({fetching: false, list})
}

export const folderPublicationsSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}

export const publicationRequest = (state, {id}) => {
  return state.merge({fetching: true})
}

export const publicationSuccess = (state, {focusRow}) => {
  return state.merge({fetching: false, focusRow})
}

export const publicationsReset = state => {
  return state.merge({
    list: null,
    fetching: false,

    followAuthorFetching: false,

    savePublicationResult: null,
    savePublicationFetching: false,

    reportReasons: null,
    reportReasonsFetching: false,

    sendReportResult: null,
    sendReportFetching: false,

    deleteListPublicationResult: null,
    deleteListPublicationFetching: false,

    page: 1,
    page_size: 12,

    focusRow: null,
  })
}

export const followAuthorRequest = (state, {authorId}) => {
  return state.merge({followAuthorFetching: true})
}

export const followAuthorSuccess = (state, {authorId, followed}) => {
  const newResults = state.list?.results.map(post => {
    if (post.author.id === authorId) {
      return {...post, author: {...post.author, is_following: followed}}
    } else {
      return {...post}
    }
  })

  const newList = state.list ? {...state.list, results: [...newResults]} : null

  const newFocusRow = state.focusRow ? {...state.focusRow} : null
  if (state.focusRow) {
    if (state.focusRow.author.id === authorId) newFocusRow.author = {...state.focusRow.author, is_following: followed}
  }

  const newAuthor = state.list?.author ? {...state.list?.author} : null
  if (state.list?.author) {
    if (state.list?.author.id === authorId) newAuthor.is_following = followed
  }

  return state.merge({list: {...newList, author: newAuthor}, focusRow: newFocusRow})
}

export const savePublicationRequest = (state, {publicationId, folderId}) => {
  return state.merge({savePublicationFetching: true})
}

export const savePublicationSuccess = (state, {publicationId, saved}) => {
  const newResults = state.list?.results.map(post => {
    if (post.id === publicationId) {
      return {...post, is_saved: saved}
    } else {
      return {...post}
    }
  })
  const newList = {...state.list, results: [...newResults]}

  const newFocusRow = state.focusRow ? {...state.focusRow} : null
  if (state.focusRow) {
    if (state.focusRow.id === publicationId) newFocusRow.is_saved = saved
  }

  return state.merge({list: newList, focusRow: newFocusRow, savePublicationResult: {id: publicationId, saved: saved}})
}

export const savePublicationReset = state => {
  return state.merge({savePublicationResult: null})
}

export const deleteRestorePublicationRequest = (state, {publicationId, data}) => {
  return state.merge({deleteRestorePublicationFetching: true})
}

export const deleteRestorePublicationSuccess = (state, {deleteRestoreResult, publicationId}) => {
  console.log('publicationId', publicationId)

  const newResults = state.list?.results.filter(post => post.id !== +publicationId)
  const newList = {...state.list, results: [...newResults]}

  console.log('newList', newList)

  return state.merge({list: {...newList}, deleteRestorePublicationFetching: false, deleteRestoreResult})
}

export const deleteRestorePublicationReset = (state, {}) => {
  return state.merge({deleteRestorePublicationFetching: false, deleteRestoreResult: null})
}

export const publicationReset = state => {
  return state.merge({focusRow: null})
}

export const publicationsFetchingReset = state => {
  return state.merge({
    fetching: false,
    followAuthorFetching: false,
    savePublicationFetching: false,
    deleteListPublicationFetching: false,
    deleteRestorePublicationFetching: false,
  })
}

export const setPublicationsPageColumnSize = (state, {page_column_size}) => {
  return state.merge({page_column_size})
}

export const reportReasonsRequest = (state, {}) => {
  return state.merge({reportReasonsFetching: true})
}
export const reportReasonsSuccess = (state, {reportReasons}) => {
  return state.merge({reportReasonsFetching: false, reportReasons})
}
export const reportReasonsReset = state => {
  return state.merge({reportSendFetching: false, reportReasons: null})
}

export const sendReportRequest = (state, {id, data}) => {
  return state.merge({sendReportFetching: true})
}
export const sendReportSuccess = (state, {sendReportResult}) => {
  return state.merge({sendReportFetching: false, sendReportResult})
}
export const sendReportReset = state => {
  return state.merge({sendReportFetching: false, sendReportResult: null})
}

export const reportFetchingReset = state => {
  return state.merge({
    reportReasonsFetching: false,
    sendReportFetching: false,
  })
}

export const followingSavedCountRequest = state => {
  return state.merge({
    followingSavedCountFetching: true,
  })
}

export const followingSavedCountSuccess = (state, {followingSavedCount}) => {
  return state.merge({
    followingSavedCountFetching: false,
    followingSavedCount,
  })
}

export const followingSavedCountReset = state => {
  return state.merge({
    followingSavedCountFetching: false,
    followingSavedCount: null,
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.PUBLICATIONS_REQUEST]: publicationsRequest,
  [Types.PUBLICATIONS_SUCCESS]: publicationsSuccess,

  [Types.FOLLOWING_PUBLICATIONS_REQUEST]: followingPublicationsRequest,
  [Types.FOLLOWING_PUBLICATIONS_SUCCESS]: followingPublicationsSuccess,

  [Types.ADVERTISER_PUBLICATIONS_REQUEST]: advertiserPublicationsRequest,
  [Types.ADVERTISER_PUBLICATIONS_SUCCESS]: advertiserPublicationsSuccess,

  [Types.FOLDER_PUBLICATIONS_REQUEST]: folderPublicationsRequest,
  [Types.FOLDER_PUBLICATIONS_SUCCESS]: folderPublicationsSuccess,

  [Types.PREPARED_PUBLICATIONS_REQUEST]: preparedPublicationsRequest,
  [Types.PREPARED_PUBLICATIONS_SUCCESS]: preparedPublicationsSuccess,

  [Types.SCHEDULED_PUBLICATIONS_REQUEST]: scheduledPublicationsRequest,
  [Types.SCHEDULED_PUBLICATIONS_SUCCESS]: scheduledPublicationsSuccess,

  [Types.LIST_PUBLICATIONS_REQUEST]: listPublicationsRequest,
  [Types.LIST_PUBLICATIONS_SUCCESS]: listPublicationsSuccess,

  [Types.PUBLICATION_REQUEST]: publicationRequest,
  [Types.PUBLICATION_SUCCESS]: publicationSuccess,

  [Types.FOLLOW_AUTHOR_REQUEST]: followAuthorRequest,
  [Types.FOLLOW_AUTHOR_SUCCESS]: followAuthorSuccess,

  [Types.SAVE_PUBLICATION_REQUEST]: savePublicationRequest,
  [Types.SAVE_PUBLICATION_SUCCESS]: savePublicationSuccess,
  [Types.SAVE_PUBLICATION_RESET]: savePublicationReset,

  [Types.PUBLICATIONS_RESET]: publicationsReset,
  [Types.PUBLICATION_RESET]: publicationReset,

  [Types.PUBLICATIONS_FETCHING_RESET]: publicationsFetchingReset,
  [Types.SET_PUBLICATIONS_PAGE_COLUMN_SIZE]: setPublicationsPageColumnSize,

  [Types.REPORT_REASONS_REQUEST]: reportReasonsRequest,
  [Types.REPORT_REASONS_SUCCESS]: reportReasonsSuccess,
  [Types.REPORT_REASONS_RESET]: reportReasonsReset,
  [Types.REPORT_FETCHING_RESET]: reportFetchingReset,

  [Types.SEND_REPORT_REQUEST]: sendReportRequest,
  [Types.SEND_REPORT_SUCCESS]: sendReportSuccess,
  [Types.SEND_REPORT_RESET]: sendReportReset,

  [Types.FOLLOWING_SAVED_COUNT_REQUEST]: followingSavedCountRequest,
  [Types.FOLLOWING_SAVED_COUNT_SUCCESS]: followingSavedCountSuccess,
  [Types.FOLLOWING_SAVED_COUNT_RESET]: followingSavedCountReset,

  [Types.DELETE_LIST_PUBLICATIONS_REQUEST]: deleteListPublicationsRequest,
  [Types.DELETE_LIST_PUBLICATIONS_SUCCESS]: deleteListPublicationsSuccess,
  [Types.DELETE_LIST_PUBLICATIONS_RESET]: deleteListPublicationsReset,

  [Types.DELETE_RESTORE_PUBLICATION_REQUEST]: deleteRestorePublicationRequest,
  [Types.DELETE_RESTORE_PUBLICATION_SUCCESS]: deleteRestorePublicationSuccess,
  [Types.DELETE_RESTORE_PUBLICATION_RESET]: deleteRestorePublicationReset,
})
